import { Injectable } from '@angular/core';

import { CmsStructureModel, Occ, OccCmsPageNormalizer, PageType } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class CustomPageNormalizer extends OccCmsPageNormalizer {
  convert(source: Occ.CMSPage, target?: CmsStructureModel): CmsStructureModel {
    if (source.typeCode === PageType.RECIPE_CATEGORY_PAGE) {
      source.typeCode = PageType.CONTENT_PAGE;
    }
    return super.convert(source, target);
  }

  protected normalizePageData(source: Occ.CMSPage, target: CmsStructureModel): void {
    super.normalizePageData(source, target);
    target.page['headerDesign'] = source['headerDesign'];
    target.page['breadcrumbs'] = source['breadcrumbs'];
    target.page['showChat'] = source['showChat'];
    target.page['liveChatAgentConfig'] = source['liveChatAgentConfig'];
    target.page['titleTag'] = source['titleTag'];
    target.page['descriptionTag'] = source['descriptionTag'];
    target.page['headerTheme'] = source['headerTheme'];
    target.page['h1Tag'] = source['h1Tag'];
    target.page['externalRecipeCategoryFilter'] = source['externalRecipeCategoryFilter'];
    target.page['canonicalUrl'] = source['canonicalUrl'];
  }

  protected normalizeComponentData(source: Occ.CMSPage, target: CmsStructureModel): void {
    target.components = [];
    super.normalizeComponentData(source, target);
  }
}
